const sites = {
  backtodashboard: 'Back to Dashboard',
  confirmdestroy: 'Remove',
  destroyheading: 'Sites Removement',
  destroywarning: 'Are you sure you want to remove the following sites?',
  nositestodestroy: 'Sorry',
  nositestodestroymessage: 'Something went wrong, please try again or contact the support',
  stopdestroy: 'Cancel',
  actions: 'Actions ...',
  columns: 'Columns',
  showfilter: 'Show Filter',
  hidefilter: 'Hide Filter'

}

export default sites
